export const ActionTypes = {
    CREATE_POLL_SURVEY: "CREATE_POLL_SURVEY",
    GET_SURVEY_LIST: "GET_SURVEY_LIST",
    GET_SURVEY_BY_ID:"GET_SURVEY_BY_ID",
    GET_SURVEY_RESPONSE_RESULT:"GET_SURVEY_RESPONSE_RESULT",
    RESET_SURVEY_OBJECT:"RESET_SURVEY_OBJECT",
    ADD_SURVEY_QUESTION:"ADD_SURVEY_QUESTION",
    DELETE_SURVEY_QUESTION:"DELETE_SURVEY_QUESTION",
    ADD_SURVEY_SECTION:"ADD_SURVEY_SECTION",
    DELETE_JUST_SECTION:"DELETE_JUST_SECTION",
    DELETE_SECTION_AND_QUESTIONS:"DELETE_SECTION_AND_QUESTIONS",
    RESET_STATE: 'RESET_STATE',
    GET_SURVEY_SUMMARY_BY_ID:"GET_SURVEY_SUMMARY_BY_ID",
};
